import { z } from 'zod';
// Which dashboard tiles a staff member has hidden (t1109). The ids are stored
// as-is in the database, so they never get renamed — retire one by deleting it
// here and the saved value just stops matching anything.
export const DASHBOARD_TILE_IDS = [
    'awaiting-provisioning',
    'ready-to-sell',
    'low-stock',
    'kiosks-offline',
    'open-tickets',
    'open-tasks',
    'recent-orders',
    'recent-notifications',
    'provisioning-pipeline',
    'staff',
    'on-the-clock',
    'signed-in-now',
];
export const dashboardTileIdSchema = z.enum(DASHBOARD_TILE_IDS);
/** Loose strings on the way out: a tile retired in a later release must never
 *  break the route or the page for someone who had hidden it. */
export const staffDashboardPrefsSchema = z.object({
    hiddenTiles: z.array(z.string()),
});
export const updateStaffDashboardPrefsSchema = z.object({
    hiddenTiles: z.array(dashboardTileIdSchema).max(DASHBOARD_TILE_IDS.length),
});
//# sourceMappingURL=dashboard.js.map